import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Box } from 'reflexbox';
import {
  Input,
  Button,
  Text,
  Divider,
  Message,
} from 'rebass';
import Loader from 'react-loading';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

import config from 'frontend/config';
import { If } from 'frontend/components';

class LoginPanel extends React.Component {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,

    onViewRegisterClick: PropTypes.func.isRequired,
    onViewForgotClick: PropTypes.func.isRequired,
  };

  state = {
    email: '',
    password: '',

    loading: false,
    error: null,
    failCount: 0,
  };

  loginOnEnter = (e) => {
    if (e.key === 'Enter') {
      this.login();
    }
  };

  login = () => {
    if (this.state.loading) {
      return;
    }

    // check email for email-i-ness
    if (!this.state.email) {
      this.setState({ error: 'No email entered' });
      return;
    }

    // make sure password is long enough
    if (!this.state.password) {
      this.setState({ error: 'No password entered' });
      return;
    }

    this.setState({ loading: true, error: null });
    axios.post('/api/login', {
      email: this.state.email,
      password: this.state.password,
    }).then((response) => {
      this.props.onSuccess(_.cloneDeep(response.data));
    }).catch(error => {
      let errorMessage = 'Unknown error occurred';
      if (error.response && error.response.status === 401) {
        errorMessage = 'Invalid email or password';
      } else if (error.response && error.response.status === 429) {
        errorMessage = 'Too many login attempts, try again in 15 minutes';
      } else if (error.response && error.response.status === 502) {
        errorMessage = 'Temporary server error - please try again';
      } else if (!error.response) {
        errorMessage = 'A network error occurred - check your connectivity';
      } else {
        Sentry.captureException(error);
      }
      this.setState(prevState => ({
        loading: false,
        failCount: prevState.failCount + 1,
        error: errorMessage,
      }));
    });
  };

  render() {
    const { onViewRegisterClick, onViewForgotClick } = this.props;
    return (
      <Box>
        <form name="login" id="loginForm" onSubmit={e => e.preventDefault()}>
          {
            this.state.error
              ? (
                <Message theme="warning" p={1}>
                  {this.state.error}
                </Message>
              ) :
              null
          }
          <If
            condition={this.state.failCount >= 2}
            then={() => (
              <Text color={config.colors.red} mb={1} bold>
                If you are having trouble logging in, you can try the
                {' '}
                <a href="#forgot" onClick={onViewForgotClick}>
                  forgot password
                </a>
                {' '}
                page.
              </Text>
            )}
          />
          <Input
            label="Email"
            id="loginEmail"
            name="email"
            type="email"
            maxLength={254}
            value={this.state.email}
            onChange={e => this.setState({ email: e.target.value })}
            onKeyPress={this.loginOnEnter}
          />
          <Input
            label="Password"
            id="loginPassword"
            name="password"
            type="password"
            maxLength={255}
            value={this.state.password}
            onChange={e => this.setState({ password: e.target.value })}
            onKeyPress={this.loginOnEnter}
          />
          <Flex align="center">
            <Box mr={1}>
              <Button
                id="loginSubmit"
                theme="success"
                disabled={this.state.loading}
                onClick={this.login}
              >
                Login
              </Button>
            </Box>
            <Box>
              {
                this.state.loading
                  ? (
                    <Loader
                      type="spin"
                      color={config.colors.green}
                      height={20}
                      width={20}
                      delay={100}
                    />
                  ) :
                  null
              }
            </Box>
          </Flex>
          <Divider my={1} />
          <Text>
            <a href="#create" onClick={onViewRegisterClick}>
              Create an account
            </a>
          </Text>
          <Text>
            <a href="#forgot" onClick={onViewForgotClick}>
              Forgot password?
            </a>
          </Text>
        </form>
      </Box>
    );
  }
}

export default LoginPanel;
